// extracted by mini-css-extract-plugin
module.exports = {"InputBookingTargetSwitch":"InputBookingTargetSwitch_InputBookingTargetSwitch___tnwL"};